import { Component } from '@angular/core';
import { KeycloakService } from 'keycloak-angular';
import { GatewayConnectionService } from 'src/app/services/apiHandler/gateway-connection/gateway-connection.service';
import { RoleService } from 'src/app/services/helper/role-handling-helper';

@Component({
  selector: 'app-no-permition',
  templateUrl: './no-permition.component.html',
  styleUrls: ['./no-permition.component.scss']
})
export class NoPermitionComponent {

  constructor(private keycloak: KeycloakService, private gatewayService: GatewayConnectionService, public roleHandling: RoleService) {
    this.gatewayService.aliveCheckSub.unsubscribe();
  }

  logout() {
    this.keycloak.logout();
  }

}
